<!-- eslint-disable prettier/prettier -->
<template>
  <article class="text-darkGray-1">
    <em> Gäller fr.o.m den 31 januari 2022 </em>
    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Personuppgiftsansvarig</h2>
      <p class="">
        Personuppgiftsansvarig för behandlingen såvitt gäller innehållet i Din ansökan i Ansökningsportal.se är:
        <div v-if="props?.company?.DisplayName?.data" class="font-semibold">
          <p>{{ props?.company?.DisplayName?.data }} <span class="font-normal">(nedan kallat "Bolaget")</span></p>
          <p>{{ props?.company?.OrganisationNumber.data }}</p>
          <p>{{ props?.company?.Address?.data }}</p>
          <p>{{ props?.company?.ZipCode?.data }} {{ props?.company?.City?.data }}</p>
          <p></p>
          <p class="mt-2"><span class="font-normal">Kontaktuppgift: </span>{{ props?.company?.GdprContact.data || ''}}</p>
        </div>
          <p v-else class="text-red-2 mt-2">Uppgift saknas</p>

      </p>
    </div>
    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Ändamål</h2>
      <p class="">
Personuppgifterna används för arbetssökandes kontakter med Bolaget och läggs till grund för manuella beslut i rekryteringsärenden. Uppgifterna kan även användas i personalliggare, i samband med ansökningar om sponsring.

      </p>
    </div>
    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Den rättsliga grunden för behandlingen</h2>
      <p class="">Behandlingens rättsliga grund är <em>samtycke</em>.</p>
    </div>
    <div 
      v-if="props?.company?.Container?.DTO?.id !== 393"
      class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Mottagare</h2>
      <p class="">
        De mottagare som ska ta del av personuppgifterna är rekryteringsansvariga, HR-ansvariga och/eller ansvariga för beslut om sponsring.
Personuppgifter lämnas endast ut till andra bolag om det behövs på grund av gällande rätt, för att skydda Bolagets/tredje parts rättigheter.
      </p>
    </div>
    <div 
      v-else-if="props?.company?.Container?.DTO?.id === 393" 
      class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Mottagare</h2>
      <p class="">
        De mottagare som ska ta del av personuppgifterna är rekryteringsansvariga hos bolaget och dess medlemsföretag, HR-ansvariga och/eller ansvariga för beslut om sponsring. Personuppgifter lämnas endast ut till andra bolag om det behövs på grund av gällande rätt, för att skydda Bolagets/tredje parts rättigheter.
      </p>
    </div>

    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Lagringstid</h2>
      <p class="">
        Personuppgifterna lagras under maximalt 36 månaders tid från att Bolaget eller registrerade har tillfört Bolaget personuppgifterna. Personuppgifterna sparas aldrig längre än vad som är nödvändigt för respektive ändamål.
      </p>
    </div>

    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Dina rättigheter</h2>
      <p class="">
        Som registrerad har Du rätt att av Bolaget utan kostnad begära tillgång till, och rättelse eller radering av, personuppgifter eller begränsning av behandling som rör Dig eller att invända mot behandling samt dataportabilitet. Vissa uppgifter kan inte raderas om de måste sparas enligt gällande rätt.
      </p>
      <p>
        Du har rätt att när som helst återkalla Ditt samtycke till behandlingen, utan att detta påverkar lagligheten av behandlingen på grundval av samtycket, innan detta återkallades. Om det finns ett annat avtal som Du blir del av indirekt när Du lämnar samtycket kan inte samtycket återkallas direkt utan att det först tas hänsyn till avtalet.
      </p>

      <p>Begäran enligt ovan ska skriftligen skickas till:</p>

          <p v-if="props?.company?.GdprAddress.data" class="font-semibold" v-html="props?.company?.GdprAddress.data"></p>

        <p v-else class="text-red-2">Uppgift saknas</p>

      <p>Du har rätt att ge in klagomål till <a href="https://www.imy.se/privatperson/utfora-arenden/lamna-ett-klagomal/" target="_blank" class="text-blue-1 underline" >Integritetsskyddsmyndigheten.</a></p>

      <p>
Ditt tillhandahållande av personuppgifter är ett krav som är nödvändigt för att framgent kunna ingå avtal med Bolaget. En följd av att inte lämna personuppgifter, eller att återkalla ett lämnat samtycke, är att Bolaget inte kan erbjuda tjänsten, de möjligheter som tjänsten innebär eller tillhandahålla ytterligare information.

      </p>
    </div>
    <div v-if="props?.company?.Container?.DTO?.id === 393" class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Våra medlemsföretag</h2>
      <div v-html="props.company.Members.data"></div>
      
    </div>
    

  </article>
</template>
<script setup lang="ts">
import { Profile } from "@/models/Profile";
import { anyTypeAnnotation } from "@babel/types";
import { defineProps, onMounted } from "vue";


const props = defineProps({
  company: {
    type: Profile,
    required: true
  },
});

</script>
